/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_TicketInputs */

const en_common_auth_gate_action_ticket = /** @type {(inputs: Common_Auth_Gate_Action_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact support`)
};

const zh_common_auth_gate_action_ticket = /** @type {(inputs: Common_Auth_Gate_Action_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系客服`)
};

/**
* | output |
* | --- |
* | "contact support" |
*
* @param {Common_Auth_Gate_Action_TicketInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_ticket = /** @type {((inputs?: Common_Auth_Gate_Action_TicketInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_TicketInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_ticket(inputs)
	return zh_common_auth_gate_action_ticket(inputs)
});
export { common_auth_gate_action_ticket as "common.auth.gate.action.ticket" }